import { render, staticRenderFns } from "./PrivacyPolicyTab.vue?vue&type=template&id=24be4b18&scoped=true"
import script from "./PrivacyPolicyTab.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyTab.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyTab.vue?vue&type=style&index=0&id=24be4b18&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24be4b18",
  null
  
)

export default component.exports